module.exports = __webpack_public_path__ + "img/vitec-logo.53196889.svg";